export default {
  classes: {
    container: 'relative w-full',
    activator: 'relative w-full cursor-pointer',
    base: 'flex flex-col absolute w-full top-0 bg-white rounded z-20 shadow-xl',
    above: 'bottom-full top-unset',
  },
}
